__turbopack_context__.v({
  "newHeroContainer": "layout-variants-module-scss-module___QlpXa__newHeroContainer",
  "similarListingsContainer": "layout-variants-module-scss-module___QlpXa__similarListingsContainer",
});
